<template>
  <v-app>

    <v-dialog
        v-model="dialog_detail"
        scrollable
        max-width="800"
      >
          <v-card>
            <v-card-text align="left" class="pt-3" style="color:black">
                หมายเลขคำสั่งซื้อ : {{ orderdetail.order_id }}
                <v-divider></v-divider>
                <v-row class="mb-n4">
                  <v-col cols="6">
                    <div>{{ orderdetail.product_name }} {{ orderdetail.item_name }}</div>
                    <div>ราคาสินค้า : {{ orderdetail.item_price }} บาท</div>
                    <div>ค่าขนส่ง : {{ orderdetail.item_fee }} บาท</div>
                    <div>รวมที่ต้องจ่าย : {{ parseInt(orderdetail.item_price) + parseInt(orderdetail.item_fee) }} บาท</div>
                    <div class="mt-1">{{ orderdetail.status == 'ORDERED' ? "รอการชำระเงิน" : "" }}</div>
                  </v-col>
                  <v-col cols="6">
                    <v-btn v-if="orderdetail.status == 'ORDERED'" style="color:white" rounded color="green"
                      @click="$router.push({path:'/special/market/pay/' + orderdetail.order_id})"
                    >ชำระเงินตอนนี้</v-btn>
                  </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-subtitle align="left">

              <div style="color:black" class="mt-2">สั่งซื้อเมื่อ : {{ orderdetail.order_date }}</div>

              <div style="color:black" class="mt-2">ข้อมูลจัดส่ง</div>
              <div>{{ orderdetail.reciver_name }} ({{ orderdetail.reciver_tel }})</div>
              <div>{{ orderdetail.reciver_address_1 + ' ' + orderdetail.reciver_address_2 + ' ' + orderdetail.reciver_address_3 }}</div>
            
              <div v-if="orderdetail.is_taxinvoice">
                <div style="color:black" class="mt-2">ข้อมูลผู้เสียภาษี</div>
                <div>{{ orderdetail.tax_email }}</div>
                <div>{{ orderdetail.tax_name }} ({{ orderdetail.tax_id }})</div>
                <div>{{ orderdetail.tax_address_1 + ' ' + orderdetail.tax_address_2 + ' ' + orderdetail.tax_address_3 }}</div>
              </div>
            </v-card-subtitle>
          </v-card>
      </v-dialog>

    <div>
      <div class="text-h6 mt-6">
          <v-icon large>mdi-cart-outline</v-icon>รายการคำสั่งซื้อของฉัน
      </div>
      <v-list 
      class="mt-2">
        <v-list-item
          class="ma-3"
          align="left"
          v-for="(item) in orderlist"
          :key="item.order_id"
          style="border: 4px solid #D7FF66;"
        >
          <v-list-item-content v-on:click="showdetail(item.order_id)">
            <v-row class="mt-n2">
              <v-col cols="6">
                <v-list-item-title>REF : {{ item.order_id }}</v-list-item-title>
                <div class="mt-1">{{ item.order_name }}</div>
                <v-list-item-subtitle class="mt-1">
                  {{ item.order_date }}
                </v-list-item-subtitle>
              </v-col>
              <v-col cols="6" class="text-h7">
                <div>{{ item.item_name }}</div>
                <div class="mt-1">{{ item.status == 'ORDERED' ? "รอการชำระเงิน" : "" }}</div>
              </v-col>
            </v-row>
            <v-list-item-subtitle class="mt-n2">
              {{ item.reciver_address_3 }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </v-app>
</template>


<script>

import axios from 'axios';
import config from '@/../config.js'
import Member from '@/models/instance/Member'

export default {
  data () {
    return {
      orderlist : [],
      dialog_detail: false,
      orderdetail : {}
    }
  },
  mounted : function () {
    this.reload()
  },
  methods: {
    showdetail(order_id){
      this.dialog_detail=true
      var que = this.$store.commit('addLoading')
      axios
      .post(config.api.url.line.specialmarket.get_orderdetail
        ,{ order_id: order_id}
        ,{ headers: Member.getTokenHeader()}
      )
      .then(response => {
        this.$store.commit('finishLoading',que)
        this.orderdetail = response.data
        
        var d = new Date(this.orderdetail.order_date)
        d.setHours(d.getHours()+7)
        this.orderdetail.order_date = d.toISOString().substring(0,10) + ' ' + d.toISOString().substring(11,19);

      })
    },
    reload(){
      var que = this.$store.commit('addLoading')
      axios
      .post(config.api.url.line.specialmarket.get_orderlist
        ,{}
        ,{ headers: Member.getTokenHeader()}
      )
      .then(response => {
        this.$store.commit('finishLoading',que)
        this.orderlist = response.data
        this.orderlist.forEach((v,i,arr)=>{
          var d = new Date(v.order_date)
          d.setHours(d.getHours()+7)
          arr[i]['order_date'] = d.toISOString().substring(0,10) + ' ' + d.toISOString().substring(11,19);
        })
      })
    }
  }
}
</script>